import { PasswordInput as StandardPasswordInput } from '@/components/inputs/PasswordInput'
import { type PasswordProps } from 'antd/lib/input'

import styles from './styles.module.scss'

export function PasswordInput(props: PasswordProps) {
  return <StandardPasswordInput {...props} className={styles.input} />
}
